import type { LucideIcon } from "lucide-react";
import { T } from "@/uniq/theme";

// 管理画面のページ内タイトル行 (ヘッダーはタイトルを持たない = Unizo ScreenTitle 規約)。
// アイコン + 見出し + 対象アンケート名。指名割当 / 集計で共通。
export default function AdminScreenTitle({ icon: Icon, title, surveyName }: {
  icon: LucideIcon;
  title: string;
  surveyName?: string;
}) {
  return (
    <div style={{ margin: "2px 0 14px" }}>
      <h1 style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 20, fontWeight: 700, color: T.ink, margin: 0 }}>
        <Icon size={20} color={T.accent} style={{ flex: "none" }} />{title}
      </h1>
      {surveyName && <div style={{ fontSize: 15, fontWeight: 600, color: T.ink, marginTop: 4 }}>{surveyName}</div>}
    </div>
  );
}
